// TODO Refactor this so that the code that calls it is here too
export function payloadToData(payload: any) {
  if (payload === null || payload === undefined) return undefined;

  if (typeof payload !== 'object') {
    return { payload: payload.toString() };
  }

  if (Array.isArray(payload)) {
    return { payload: '[...]' };
  }

  const data: Record<string, any> = {};

  for (const [key, value] of Object.entries(payload)) {
    data[key] =
      typeof value === 'object' && value
        ? Array.isArray(value)
          ? '[...]'
          : '{...}'
        : String(value);
  }

  return data;
}
